import _ from 'underscore';

import allPartTypeViewConfigs from './allPartTypeViewConfigs';

export default (partTypeName: $TSFixMe) => {
  if (!_(allPartTypeViewConfigs).has(partTypeName)) {
    throw new Error('Unrecognized review part type: "' + partTypeName + '"');
  }

  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  return allPartTypeViewConfigs[partTypeName];
};
